import api from './client';

const crmAPI = {
  setupTenant: (data) => api.post('/crm/tenants/setup', data),
  getMyTenant: () => api.get('/crm/tenants/mine'),
  updateTenant: (data) => api.patch('/crm/tenants/mine', data),
  deleteTenant: () => api.delete('/crm/tenants/mine'),
  uploadLogo: (file) => { const fd = new FormData(); fd.append('file', file); return api.post('/crm/tenants/mine/logo', fd, { headers: { 'Content-Type': 'multipart/form-data' } }); },
  getTenantUsers: () => api.get('/crm/tenants/mine/users'),
  addTenantUser: (data) => api.post('/crm/tenants/mine/users', data),
  getPipeline: () => api.get('/crm/pipeline'),
  createStage: (data) => api.post('/crm/pipeline', data),
  getSources: () => api.get('/crm/sources'),
  listContacts: (params) => api.get('/crm/contacts', { params }),
  getContact: (id) => api.get(`/crm/contacts/${id}`),
  createContact: (data) => api.post('/crm/contacts', data),
  updateContact: (id, data) => api.patch(`/crm/contacts/${id}`, data),
  deleteContact: (id) => api.delete(`/crm/contacts/${id}`),
  scoreContact: (id) => api.post(`/crm/contacts/${id}/score`),
  getBriefing: (id) => api.post(`/crm/contacts/${id}/briefing`),
  listDeals: (params) => api.get('/crm/deals', { params }),
  createDeal: (data) => api.post('/crm/deals', data),
  updateDeal: (id, data) => api.patch(`/crm/deals/${id}`, data),
  listActivities: (params) => api.get('/crm/activities', { params }),
  createActivity: (data) => api.post('/crm/activities', data),
  extractActivity: (text) => api.post('/crm/activities/extract', { text }),
  updateActivity: (id, data) => api.put(`/crm/activities/${id}`, data),
  deleteActivity: (id) => api.delete(`/crm/activities/${id}`),
  getDashboard: () => api.get('/crm/dashboard/metrics'),
  listProducts: () => api.get('/crm/products'),
  createProduct: (data) => api.post('/crm/products', data),
  updateProduct: (id, data) => api.patch(`/crm/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/crm/products/${id}`),
  getBusinessHours: () => api.get('/crm/business-hours'),
  updateBusinessHours: (day, data) => api.patch(`/crm/business-hours/${day}`, data),
  // Appointments
  listAppointments: () => api.get('/crm/appointments'),
  createAppointment: (data) => api.post('/crm/appointments', data),
  updateAppointment: (id, data) => api.patch(`/crm/appointments/${id}`, data),
  deleteAppointment: (id) => api.delete(`/crm/appointments/${id}`),
  listDeletedAppointments: () => api.get('/crm/appointments/deleted'),
};

export default crmAPI;
